import PointsHistoryList from "../../components/pointsHistory/PointsHistoryList";
import NavLinksAdmin from "../../components/navlinksAdmin/NavLinksAdmin";

const AdminPointsHistory = () => {
  return (
    <div className="inside-page-container-blk">
      <div className="admin-page-main-container">
        <NavLinksAdmin />
        <div>
          <PointsHistoryList />
        </div>
      </div>
    </div>
  );
};

export default AdminPointsHistory;
